import React from "react"
import autobind from "class-autobind"
import { TextField, Dialog, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import { IClientType } from "../../../models"
import * as utils from "../../../helpers/utils"
interface IProps {
	editClientType: IClientType
	clientTypes: IClientType[]
	handleClose(): void
	handleAdd(clientType: IClientType): void
	handleUpdate(clientType: IClientType): void
}
interface IState {
	name: string
	errorName: string
	abbreviation: string
	errorAbbreviation: string
}

export default class AddClientTypeDialog extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			name: props.editClientType ? props.editClientType.Name : "",
			errorName: null,
			abbreviation: props.editClientType ? props.editClientType.Abbreviation : "",
			errorAbbreviation: null
		}
		autobind(this)
	}

	checkValidate() {
		let isValidate = true

		if (!this.state.name.trim()) {
			this.setState({ errorName: strings.This_field_is_required })
			isValidate = false
		}
		else {
			if (this.props.clientTypes.filter(i => this.props.editClientType ? this.props.editClientType.Id !== i.Id : true).find(i => i.Name === this.state.name.trim())) {
				this.setState({ errorName: strings.Name_is_duplicated })
				isValidate = false
			}
			else {
				this.setState({ errorName: null })
			}
		}

		if (!this.state.abbreviation.trim()) {
			this.setState({ errorAbbreviation: strings.This_field_is_required })
			isValidate = false
		}
		else {
			if (this.props.clientTypes.filter(i => this.props.editClientType ? this.props.editClientType.Id !== i.Id : true).find(i => i.Abbreviation === this.state.abbreviation.trim())) {
				this.setState({ errorAbbreviation: strings.Abbreviation_is_duplicated })
				isValidate = false
			}
			else {
				this.setState({ errorAbbreviation: null })
			}
		}

		return isValidate
	}

	handleRequestSave() {
		if (!this.checkValidate()) return
		const clientType: IClientType = {
			Id: this.props.editClientType ? this.props.editClientType.Id : utils.guid(),
			Name: this.state.name.trim(),
			Abbreviation: this.state.abbreviation.trim(),
			Active: true
		}
		this.props.editClientType ?
			this.props.handleUpdate(clientType) :
			this.props.handleAdd(clientType)
	}

	render() {
		return (
			<Dialog
				open
				title={this.props.editClientType ? strings.Edit_Client_Type : strings.Add_Client_Type}
				titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
				actions={[
					<FlatButton data-intercom-target={"menu-AccountSettings-ClientSettings-ClientTypeTab-Btn-CloseAddPayGroupDialog"} key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.handleClose} />,
					<FlatButton data-intercom-target={"menu-AccountSettings-ClientSettings-ClientTypeTab-Btn-SavePayGroup"} key="save" label={strings.SAVE} primary onTouchTap={this.handleRequestSave} />
				]}
			>
				<div style={{ paddingLeft: 15, paddingRight: 15 }}>
					<div>
						<TextField
							data-intercom-target={"menu-AccountSettings-ClientSettings-ClientTypeTab-Add-Entry-Name"}
							floatingLabelText={strings.Name}
							value={this.state.name}
							onChange={(e, value) => this.setState({ name: value }, () =>
								this.checkValidate()
							)}
							errorText={this.state.errorName}
							errorStyle={{ position: "absolute", bottom: -12 }}
						/>
					</div>
					<div>
						<TextField
							data-intercom-target={"menu-AccountSettings-ClientSettings-ClientTypeTab-Add-Entry-Abbreviation"}
							floatingLabelText={strings.Abbreviation}
							value={this.state.abbreviation}
							onChange={(e, value) => this.setState({ abbreviation: value }, () =>
								this.checkValidate()
							)}
							errorText={this.state.errorAbbreviation}
							errorStyle={{ position: "absolute", bottom: -12 }}
						/>
					</div>
				</div>
			</Dialog>
		)
	}
}
